/**
 * 落地页入口 JS（webpack bundle，由 htmlWebpackPlugin 自动注入）
 * 功能：登录态判断 + 按钮跳转 + OpenClaw 弹窗/下载
 */
function onReady(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

onReady(function () {
  var token = localStorage.getItem("token");
  var loginBtn = document.getElementById("loginBtn");
  var mainBtn = document.getElementById("mainBtn");

  // 更新登录按钮文字
  if (loginBtn) {
    loginBtn.textContent = token ? "管理中心" : "登录/注册";
  }

  // 绑定跳转逻辑（与 landPage/index.vue 中 goLogin 方法一致）
  function goLogin() {
    if (token) {
      window.location.href = "/home";
    } else {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  }

  if (loginBtn) loginBtn.addEventListener("click", goLogin);
  if (mainBtn) mainBtn.addEventListener("click", goLogin);

  // OpenClaw 相关交互
  var installModal = document.getElementById("installModal");
  var installCmdBtn = document.getElementById("installCmdBtn");
  var installModalClose = document.getElementById("installModalClose");
  var installCopyBtn = document.getElementById("installCopyBtn");
  var openClawDownloadUrl =
    "https://www.jielong.vip/download/skills/jielong-activity-creator.zip";
  var brandName =
    (installModal && installModal.getAttribute("data-brand-name")) || "报名管家";

  function openInstallModal() {
    if (installModal) installModal.classList.add("show");
  }
  function closeInstallModal() {
    if (installModal) installModal.classList.remove("show");
  }

  if (installCmdBtn) installCmdBtn.addEventListener("click", openInstallModal);
  if (installModalClose)
    installModalClose.addEventListener("click", closeInstallModal);
  if (installModal) {
    installModal.addEventListener("click", function (e) {
      if (e.target === installModal) closeInstallModal();
    });
  }

  // 复制安装指令
  function copyInstallCommand() {
    var text =
      "【请帮我下载并加载这个技能：\n技能名称：" +
      brandName +
      "\n下载地址：" +
      openClawDownloadUrl +
      "\n请下载该文件，然后将其加载到你的技能库中，以便我可以使用这个技能。】";
    function onCopied() {
      alert("已复制到剪贴板");
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onCopied);
    } else {
      var textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
      } catch (e) {
        /* ignore */
      }
      document.body.removeChild(textarea);
      onCopied();
    }
  }
  if (installCopyBtn)
    installCopyBtn.addEventListener("click", copyInstallCommand);

  // 轮播图
  var carouselWrapper = document.getElementById("bannerCarousel");
  if (carouselWrapper) {
    var slides = carouselWrapper.querySelectorAll(".carousel-slide");
    var dots = carouselWrapper.querySelectorAll(".carousel-dot");
    var prevBtn = document.getElementById("carouselPrev");
    var nextBtn = document.getElementById("carouselNext");
    var total = slides.length;
    var current = 0;
    var timer = null;

    var show = function (idx) {
      current = (idx + total) % total;
      slides.forEach(function (s, i) {
        s.classList.toggle("active", i === current);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("active", i === current);
      });
    };
    var next = function () {
      show(current + 1);
      restartTimer();
    };
    var prev = function () {
      show(current - 1);
      restartTimer();
    };
    var startTimer = function () {
      timer = setInterval(function () {
        show(current + 1);
      }, 5000);
    };
    var restartTimer = function () {
      if (timer) clearInterval(timer);
      startTimer();
    };

    if (nextBtn) nextBtn.addEventListener("click", next);
    if (prevBtn) prevBtn.addEventListener("click", prev);
    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        show(parseInt(d.getAttribute("data-idx"), 10));
        restartTimer();
      });
    });

    startTimer();
  }
});
